import {gql} from "apollo-boost";


export const NOTIFICATIONS_READ = gql`
  mutation ReadNotification($ids: [ID]) {
      readNotification(ids : $ids){
        label
        message
      }
    }`;